import { Injectable } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root',
})
export class UiStateService {
  constructor(
    private spinner: NgxSpinnerService,
    private message: NzMessageService
  ) {}

  setLoaderVisible(value: boolean): void {
    if (value) {
      this.spinner.show(undefined, {
        type: 'ball-pulse',
        size: 'small',
        bdColor: 'rgb(0,0,0,0.2)',
        color: '#00000',
        fullScreen: true,
      });
      return;
    }
    this.spinner.hide();
  }

  showMessage(type: string, message: string, durationMs: number = 7000): void {
    this.message.create(type.toString(), message, { nzDuration: durationMs });
  }
}
